import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  salesChannelFeatureKey,
  salesChannelFeatureState
} from './sales-channel.reducer';

export const salesChannelState =
  createFeatureSelector<salesChannelFeatureState>(salesChannelFeatureKey);

export const selectSalesChannelLoadingStatus = createSelector(
  salesChannelState,
  ({ status }) => status
);

export const selectWebSaleChannelData = createSelector(
  salesChannelState,
  ({ web }) => web
);

export const selectWebSaleChannelDataWithAppId = createSelector(
  salesChannelState,
  ({ web, appId }) => {
    return {
      web,
      appId
    };
  }
);

export const selectMobileSaleChannelData = createSelector(
  salesChannelState,
  ({ mobile }) => mobile
);

export const selectMobileSaleChannelDataWithAppId = createSelector(
  salesChannelState,
  ({ mobile, appId }) => {
    return {
      mobile,
      appId
    };
  }
);

export const selectMobileSaleChannelCategoryDisplayType = createSelector(
  salesChannelState,
  ({ mobile }) => {
    const mobileChannelInfo = mobile?.find((x) => x.platformType == 'None');
    return mobileChannelInfo.hasOwnProperty('categoryDisplayType')
      ? mobileChannelInfo.categoryDisplayType
      : 'ImageAndText';
  }
);

export const selectShopilinkSaleChannelData = createSelector(
  salesChannelState,
  ({ shopilink }) => shopilink
);

// this selector only returns the shopilink channel data not other associated channels
export const selectShopilinkData = createSelector(
  salesChannelState,
  ({ shopilink }) => {
    const shopilinkChannels = Object.assign([], shopilink);
    const shopilinkChannelData = shopilinkChannels.findIndex(
      (x) => x.platformType == 'None'
    );
    return shopilinkChannelData == undefined ? null : shopilinkChannelData;
  }
);

export const selectShopilinkSaleChannelDataWithAppId = createSelector(
  salesChannelState,
  ({ shopilink, appId }) => {
    return {
      shopilink,
      appId
    };
  }
);

export const selectMagentySaleChannelData = createSelector(
  salesChannelState,
  ({ magenty }) => {
    return magenty;
  }
);

export const selectMagentySaleChannelDataWithAppId = createSelector(
  salesChannelState,
  ({ magenty, appId }) => {
    return {
      magenty,
      appId
    };
  }
);

export const selectEasyCollectionSaleChannelData = createSelector(
  salesChannelState,
  ({ easyCollection }) => {
    return easyCollection;
  }
);

export const selectEasyCollectionSaleChannelDataWithAppId = createSelector(
  salesChannelState,
  ({ easyCollection, appId }) => {
    return {
      easyCollection,
      appId
    };
  }
);
